import(/* webpackMode: "eager" */ "/app/src/app/(en)/case-studies/page.jsx");
